import * as types from '../actions/mercoTraysAction';

const initialState = {
  limit: '20',
  page: 0,
  totalResults: 0,
  sortBy: 'code',
  orderDirection: 'ASC',
  loading: false,
};

const mercoTraysReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_MERCO_TRAYS_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case types.CHANGE_MERCO_TRAYS_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };
    case types.CHANGE_MODAL_MERCO_TRAYS_VALUE:
      return {
        ...state,
        modalInf: {
          ...state.modalInf,
          [action.payload.key]: action.payload.value,
        },
      };

    case types.GET_MERCO_TRAYS:
      return {
        ...state,
        loading: true,
      };

    case types.GET_MERCO_TRAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        totalResults: action.payload.total,
      };

    case types.GET_MERCO_TRAYS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case types.NEW_MERCO_TRAY:
      return {
        ...state,
        loading: false,
      };

    case types.NEW_MERCO_TRAY_SUCCESS:
      return {
        ...state,
        totalResults: state.totalResults + 1,
      };

    case types.UPDATE_MERCO_TRAY:
      return {
        ...state,
        loading: false,
      };

    case types.UPDATE_MERCO_TRAY_SUCCESS:
      return {
        ...state,
        totalResults: state.totalResults + 1,
      };

    case types.DELETE_MERCO_TRAY:
      return {
        ...state,
        loading: false,
      };

    case types.DELETE_MERCO_TRAY_SUCCESS:
      return {
        ...state,
        totalResults: state.totalResults - 1,
      };

    case types.RESET_MERCO_TRAYS_STORE:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default mercoTraysReducer;
